import { useEffect, useState } from 'react'
import { useHistory, useParams } from 'react-router-dom'
import Container from '../../../../../components/Container'
import { useLoading } from '../../../../../hooks/loading'
import api from '../../../../../services/api'
import { FormMenuFood } from '../components/Form'
import { apiViewUpdate } from '../domain/api'
import { nameActions } from '../domain/info'
import { breadcrumbUpdate } from '../domain/breadcrumb'
import { toolsUpdate } from '../domain/tools'
import { useToast } from '../../../../../hooks/toast'
import { useMenuFoodContext } from '../contexts'

const MenuFoodUpdate = (): JSX.Element => {
  const { addToast } = useToast()
  const history = useHistory()
  const { id } = useParams<{ id: string }>()
  const { activeLoading, disableLoading } = useLoading()
  const [menuFood, setMenuFood] = useState<IMenuFoodData>()
  const { insertDefaultInstitutions } = useMenuFoodContext()
  useEffect(() => {
    async function loadData() {
      activeLoading()
      try {
        const response = await api.get<IMenuFoodData>(apiViewUpdate(id))
        const { data } = response

        insertDefaultInstitutions(data.menu_institutions)
        setMenuFood(data)
        disableLoading()
      } catch (err) {
        console.log(err)
        disableLoading()
        addToast({
          type: 'error',
          title: 'Error ao carregar o cardápio',
          description:
            'Houve um error ao carregar o cardápio, tente novamente mais tarde!'
        })
        // if (path.includes('update')) {
        //   history.push(`/${baseUrl}`)
        // } else {
        //   history.push(`/${baseUrl}/${path}`)
        // }
      }
    }
    loadData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeLoading, addToast, disableLoading, history])
  return (
    <Container
      pageTitle={nameActions.update.name}
      breadcrumb={breadcrumbUpdate}
      tools={toolsUpdate}
    >
      <FormMenuFood
        typeForm="update"
        initialValues={{
          idUpdate: Number(menuFood?.id),
          ...menuFood
        }}
      />
    </Container>
  )
}

export default MenuFoodUpdate
